import { Injectable, OnDestroy, NgZone } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Subject } from 'rxjs';

import { SessionService } from '../session/session.service';
import { AdminSecurityService } from '../admin/security/security.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService implements OnDestroy {
  private socket: Socket | null = null;
  public adminNewAlert$ = new Subject<any>();

  constructor(
    private sessionService: SessionService,
    private adminSecurityService: AdminSecurityService,
    private ngZone: NgZone
  ) {
    this.sessionService.sessionData$.subscribe(data => {
      if (data && data.token) {
        this.connect(data.token, data.user._id);
      } else {
        this.disconnect();
      }
    });
  }

  private connect(token: string, userId: string) {
    if (this.socket) {
      return;
    }

    // Connect to the dating namespace as configured in the backend
    const url = `${environment.baseUrl.replace('/api', '')}/dating`;
    console.log('Connecting to socket URL:', url);
    this.socket = io(url, {
      auth: {
        token: token
      },
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('[Socket] ✅ Connected! Socket ID:', this.socket?.id);
      // Join personal room for targeted events
      console.log('[Socket] Emitting user:join_room for userId:', userId);
      this.socket?.emit('user:join_room', { userId: userId });
    });

    // Listen for new admin alerts
    this.socket.on('admin:new_alert', (alert: any) => {
      console.log('[Socket] 🔔 Real-time admin alert received:', alert);
      this.ngZone.run(() => {
        this.adminNewAlert$.next(alert);
        this.adminSecurityService.incrementUnreadCount();
      });
    });

    this.socket.on('disconnect', (reason: string) => {
      console.warn('[Socket] ❌ Disconnected. Reason:', reason);
    });

    this.socket.on('connect_error', (err: Error) => {
      console.error('[Socket] 🚫 Connection error:', err.message);
    });

    this.socket.on('error', (err: any) => {
      console.error('[Socket] 🚫 Socket error:', err);
    });
  }

  private disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  ngOnDestroy() {
    this.disconnect();
  }
}
